export default __webpack_public_path__ + "static/media/Hape-Bumblebee-Pram-Chain-1.870b4bac.jpg";